import { Color, Size, Styles } from '@vivli/shared/theme';
import { DTISignupLoginButton } from '@vivli/shared/infrastructure/constants';
import { useAppConfigContext, useAuthServiceContext } from '@vivli/core/infrastructure/context';

const HEADER_LINK_Revised: React.CSSProperties = {
    ...Styles.HEADER_LINK,
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: Size.PADDING,
    paddingTop: Size.PADDING,
    color: Color.WHITE,
    fontSize: Size.FontSize.Medium,
    cursor: 'pointer'
};

export const SignupLoginButtonView = () => {
    const { signupEnabled } = useAppConfigContext();
    const { signUp, login } = useAuthServiceContext();

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {signupEnabled && (
                    <div
                        onClick={() => signUp()}
                        style={HEADER_LINK_Revised}
                        className="header_signup"
                        data-test-id={DTISignupLoginButton.HeaderSignup}
                    >
                        Sign up
                    </div>
                )}

                <div
                    onClick={() => login()}
                    style={HEADER_LINK_Revised}
                    className="header_login"
                    data-test-id={DTISignupLoginButton.HeaderLogin}
                >
                    Log In
                </div>
            </div>
        </>
    );
};
